import { CSSProperties, forwardRef } from "react";

/**
 * P7.5 — evaOS wordmark (code-rendered, no asset needed).
 * Italic serif `eva` + small mono `OS` — premium, themable, scales cleanly.
 * Used in nav, contact header, legal shell.
 */
interface Props {
  size?: "sm" | "md";
  color?: string;
  accent?: string;
  className?: string;
  style?: CSSProperties;
}

export const EvaOsMark = forwardRef<HTMLSpanElement, Props>(({ size = "md", color = "#1a1a1a", accent = "#C4823A", className, style }, ref) => {
  const evaSize = size === "sm" ? 22 : 26;
  const osSize = size === "sm" ? 10 : 11;
  const lift = size === "sm" ? 5 : 6;
  return (
    <span
      ref={ref}
      className={className}
      aria-label="evaOS"
      style={{
        display: "inline-flex",
        alignItems: "baseline",
        lineHeight: 1,
        userSelect: "none",
        ...style,
      }}
    >
      <span style={{
        fontFamily: "'Instrument Serif', 'Cormorant Garamond', Georgia, serif",
        fontStyle: "italic",
        fontWeight: 400,
        fontSize: evaSize,
        color,
        letterSpacing: "-0.02em",
      }}>
        eva
      </span>
      <span style={{
        fontFamily: "'JetBrains Mono', ui-monospace, monospace",
        fontWeight: 600,
        fontSize: osSize,
        color: accent,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        paddingLeft: 2,
        position: "relative",
        top: -lift,
      }}>
        OS
      </span>
    </span>
  );
});
EvaOsMark.displayName = "EvaOsMark";

export default EvaOsMark;